export const updateFeed = [
  {
    id: 'up-01',
    title: '雾港迷航',
    category: '电影',
    progress: '正片上线',
    detail: '悬疑冒险，全片 126 分钟，含幕后花絮一条',
    time: '10 分钟前',
    tone: 'primary',
  },
  {
    id: 'up-02',
    title: '长风渡口',
    category: '剧集',
    progress: '更新至第 18 集',
    detail: '年代群像剧，本周迎来剧情转折',
    time: '32 分钟前',
    tone: 'secondary',
  },
  {
    id: 'up-03',
    title: '星轨旅人',
    category: '动漫',
    progress: '更新至第 09 话',
    detail: '原创科幻番，画面与配乐评价稳定',
    time: '1 小时前',
    tone: 'accent',
  },
  {
    id: 'up-04',
    title: '第七个夏天',
    category: '电影',
    progress: '正片上线',
    detail: '青春成长题材，片长 108 分钟',
    time: '2 小时前',
    tone: 'primary',
  },
  {
    id: 'up-05',
    title: '周末野餐计划',
    category: '综艺',
    progress: '更新至第 06 期',
    detail: '户外生活慢综艺，本季固定嘉宾阵容',
    time: '3 小时前',
    tone: 'accent',
  },
  {
    id: 'up-06',
    title: '山与海的餐桌',
    category: '纪实',
    progress: '更新至第 04 集',
    detail: '美食人文纪录片，走访沿海与山地食材产地',
    time: '5 小时前',
    tone: 'secondary',
  },
  {
    id: 'up-07',
    title: '回声谷',
    category: '电影',
    progress: '正片上线',
    detail: '科幻短片合集，共 4 个独立故事',
    time: '今天 09:20',
    tone: 'primary',
  },
  {
    id: 'up-08',
    title: '蓝莓小镇奇遇',
    category: '动漫',
    progress: '更新至第 24 话',
    detail: '合家欢向动画，适合全年龄观看',
    time: '今天 08:05',
    tone: 'accent',
  },
];